import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { useProductMetadataContext } from "src/context/Product/Metadata/useProductMetadata";
import { QuestionnaireFormContextProvider } from "src/components/QuestionnaireForm/context/provider";
import { URLHandler } from "src/services/URLHandler";
import { getSsqDisplayTitleWithCampaign } from "src/utils/ssqTitle";
import { Loading } from "src/components/utils/Loading";
import { useGetProductPost } from "src/api/client-api/post/useGetProductPost";
import { QuestionnaireForm } from "src/components/QuestionnaireForm/layouts/QuestionnaireUpdateForm";
import { useQuestionnaireUpdateScoresParams } from "src/components/QuestionnaireForm/useQuestionnaireUpdateScoresParams";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

export const QuestionnaireUpdate = () => {
    const { selectedCompany, currentCampaign, canUser } = useFoodpilotContext();
    const { product, ssqVersion, canModifySSQ } = useProductMetadataContext();
    const { scoresParams } = useQuestionnaireUpdateScoresParams();
    const isProductUxV2 = useIsProductUxV2();
    const appearance = isProductUxV2 ? "product-v2" : "legacy";

    const postQuery = useGetProductPost({
        productId: product.id,
        companyId: selectedCompany?.id,
        campaignId: currentCampaign?.id,
        scoresQuery: scoresParams.query,
    });

    if (!selectedCompany || !ssqVersion) return <Loading appearance={appearance} />;

    const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get("returnUrl");

    // Déterminer si c'est un produit intermédiaire pour utiliser les bonnes URLs
    const isIntermediateProduct = product.isIntermediate === true;
    const urlHandlerRoutes = isIntermediateProduct ? URLHandler.intermediateProduct : URLHandler.product;

    const url = urlHandlerRoutes.ssqProduct(selectedCompany.id, product.id, selectedCompany.id);
    const ssqUrl = returnUrl ? `${url}?returnUrl=${encodeURIComponent(returnUrl)}` : url;

    return (
        <QuestionnaireFormContextProvider
            title={product.title}
            subtitle={getSsqDisplayTitleWithCampaign(ssqVersion?.ssq, currentCampaign)}
            ssqVersion={ssqVersion}
            postQuery={postQuery}
            getHeadingUrl={(headingId: number) => {
                const url = urlHandlerRoutes.ssqHeading(selectedCompany.id, product.id, selectedCompany.id, headingId);

                return returnUrl ? `${url}?returnUrl=${encodeURIComponent(returnUrl)}` : url;
            }}
            backUrl={ssqUrl}
            canEdit={canModifySSQ}
            appearance={appearance}
        >
            <QuestionnaireForm />
        </QuestionnaireFormContextProvider>
    );
};
